import React, { useEffect, useState } from 'react'
import { callApi } from '../../../context/api'
import { Button, notification, Typography, Spin } from 'antd'
import WithdrawModal from './WithdrawModal'
const SendDotsPayout = () => {
	const [loading, setLoading] = useState<boolean>(false)
	const [balanceLoading, setBalanceLoading] = useState<boolean>(false)
	const [payoutLink, setPayoutLink] = useState<string>()
	const [balance, setBalance] = useState<number>()

	useEffect(() => {
		getBalance()
	}, [])

	const getBalance = () => {
		setBalanceLoading(true)
		callApi(`/payment/send-dots/user`, { method: 'GET' })
			.then((response) => {
				setBalanceLoading(false)
				if (response.payload.data.wallet) {
					setBalance(response.payload.data.wallet.withdrawable_amount / 100)
				}
			})
			.catch(() => {
				setBalanceLoading(false)
			})
	}

	const getPayoutLink = () => {
		setLoading(true)
		callApi(`/payment/send-dots/payout-link`, { method: 'GET' })
			.then((response) => {
				setLoading(false)
				if (response.payload.data?.link) {
					setPayoutLink(response.payload.data.link)
				} else {
					notification.error({ message: 'Cannot get Payout information, please contact to support' })
				}
			})
			.catch(() => {
				setLoading(false)
			})
	}

	const onClose = () => {
		getBalance()
		setPayoutLink(null)
	}

	return (
		<section style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
			<Typography.Title style={{ margin: '0 10px 0 0' }} level={5}>
				<Typography.Text style={{ marginRight: '3px' }}>Balance:</Typography.Text>
				{balanceLoading ? (
					<Spin />
				) : (
					<Typography.Text type={balance ? 'success' : 'secondary'}>${balance}</Typography.Text>
				)}
			</Typography.Title>
			<Button loading={loading} shape="round" type="primary" onClick={getPayoutLink}>
				Withdraw
			</Button>
			{payoutLink && <WithdrawModal link={payoutLink} onClose={onClose} />}
		</section>
	)
}

export default SendDotsPayout
